import config from 'config'
import { captureException, captureMessage } from 'lib/common/logger'

export function redirectWithMessage(msg, url) {
    msg = msg || config.fallbacks.defaultMessage;
    url = url || config.fallbacks.fallbackUrl;

    /* global __DEV__ */
    if (__DEV__) {
        throw new Error(msg);
    } else {
        alert(msg);
        window.location = url;
    }

    return false;
}

export function redirectWithError(err, msg, url) {
    if (err) {
        captureException(err);
    }
    redirectWithMessage(msg, url);
}

export function redirectWithLog(logMsg, msg, url) {
    if (logMsg) {
        captureMessage(logMsg);
    }
    redirectWithMessage(msg, url);
}

export default {
    redirectWithMessage,
    redirectWithError,
    redirectWithLog
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/fallbacks.js